import React from "react"
import { getTextVariable } from "./functions"
import { TypographyProps } from "./types"
import styles from "./Typography.module.css"
import { classNames } from "@punks/ui-core"

const Typography = ({
  component,
  children,
  className,
  font,
  textTransform,
  textAlign,
  underline,
  truncate,
  color,
  colorValue,
  variant,
  lineHeight,
  lineHeightValue,
  fontSize,
  fontSizeValue,
  weight,
  weightValue,
  style,
  innerRef,
  inheritColor,
  italic,
  multiline,
  sameHeight,
  ...props
}: TypographyProps) => {
  const Tag = component ?? "div"
  const weights = getTextVariable(
    weight ?? variant,
    weightValue,
    "font-weight",
    {
      valSuffix: "w",
      valPrefix: "text",
    }
  )
  const fontSizes = getTextVariable(
    fontSize ?? variant,
    fontSizeValue,
    "font-size",
    {
      valSuffix: "s",
      valPrefix: "text",
    }
  )
  const heights = getTextVariable(
    lineHeight ?? variant,
    lineHeightValue,
    "line-height",
    {
      valSuffix: sameHeight ? "s" : "h",
      valPrefix: "text",
    }
  )

  const aligns = getTextVariable(null, textAlign, "text-align")
  const transforms = getTextVariable(null, textTransform, "text-transform")
  const colors = !inheritColor
    ? getTextVariable(color ?? variant, colorValue, "text-color", {
        valPrefix: "wp-theme-color",
      })
    : {}
  const families = getTextVariable(font, null, "font-family", {
    valPrefix: "font-family",
  })
  return (
    //@ts-ignore
    <Tag
      //@ts-ignore
      className={classNames(
        styles.root,
        {
          [styles.truncate]: truncate === true,
          [styles.underline]: underline === true,
          [styles.italic]: italic === true,
          [styles.inheritColor]: inheritColor,
          [styles.multiline]: multiline === true,
        },
        className
      )}
      style={{
        ...weights,
        ...fontSizes,
        ...heights,
        ...aligns,
        ...transforms,
        ...families,
        ...colors,
        ...style,
      }}
      {...props}
      ref={innerRef}
    >
      {children}
    </Tag>
  )
}

Typography.defaultProps = {
  variant: "body1",
}

export default Typography
